export const CANONICAL_LOCAL_FRONTEND_ORIGIN = 'https://localhost:3000';

type LocalLocation = Pick<
  Location,
  'hash' | 'hostname' | 'origin' | 'pathname' | 'search'
>;

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export const getCanonicalLocalFrontendRedirect = (
  location: LocalLocation,
): string | null => {
  if (!LOCAL_HOSTNAMES.has(location.hostname)) {
    return null;
  }
  if (location.origin === CANONICAL_LOCAL_FRONTEND_ORIGIN) {
    return null;
  }
  return `${CANONICAL_LOCAL_FRONTEND_ORIGIN}${location.pathname}${location.search}${location.hash}`;
};
